<template>
  <div class="voltage-wrapper">
    <div class="gauge gauge--voltage">
      <div class="gauge__background">
        <div class="gauge__dial-center">
          <div
            class="gauge__dial-center__indicator"
            :class="{'gauge__dial-center__indicator--overvoltage': (computedVoltage > MaxValue)}"
          />
        </div>
      </div>
      <div
        class="voltage-content"
        :class="{'voltage-content--overvoltage': (computedVoltage > MaxValue)}"
      >
        {{ computedVoltage }}V<br>
        <span
          v-if="showExpected"
          class="voltage-content__expected"
        >
          <strong :style="{color: computeStrokeColor}">
            {{ expectedVoltage + 'V' }}
          </strong> expected
        </span>
      </div>

      <div
        v-if="showExpected"
        class="voltage__expected-wrapper"
      >
        <svg
          class="voltage__expected"
          width="165"
          height="165"
          viewBox="0 0 120 120"
        >
          <circle
            class="voltage__expected__value"
            cx="60"
            cy="60"
            r="54"
            fill="none"
            stroke="#f77a52"
            stroke-width="7"
            :style="{stroke: computeStrokeColor, strokeDashoffset: computeExpectedVoltageGauge}"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import GaugeLib from '@/assets/javascript/GaugeLib.js'

export default
{
  voltageGauge: undefined, // link this later
  name: 'VoltageGauge',
  props:
  {
    voltage: {
      type: Number,
      default: null
    }
  },
  data() {
    return{
      MaxValue: 35,
      expectedVoltage: this.voltage / 100,
      showExpected: false
    }
  },
  computed: {
    computedVoltage() {
      return this.voltage / 100
    },
    computeStrokeColor() {
      return '#71c837'
    },
    computeExpectedVoltageGauge() {
      // const val = 339.292 - ((97 / this.MaxValue) * this.expectedVoltage);
      const val = 339.292 - ((97 / this.MaxValue) * this.expectedVoltage)
      return val
    }
  },
  watch:
  {
    computedVoltage() {
      this.voltageGauge.update(this.computedVoltage)
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.voltageGauge = new GaugeLib()

      this.voltageGauge.config({
        el: '.gauge.gauge--voltage',
        dialEl: '.gauge__dial-center',
        dialStart: -48.7,
        dialEnd: 48.7,
        maxValue: this.MaxValue,
        forcedUpperValue: this.MaxValue,
        status: 'active',
        baseTransform: 'translate3d(-50%, 488%, 0px)'
      })
      this.voltageGauge.update(this.computedVoltage)
    })
  }
}
</script>

<style lang="scss">
  /* Voltage Gauge TR */
  .voltage-wrapper {
    display: flex;
    justify-content: center;
    margin: 0;
    transform: translateX(-5px);
  }

  .voltage {
    &__expected-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-49.8%, 0%, 0);
      z-index: -1;
      transition: all 0.5s;
    }
    &__expected {
      &__value {
        transform-origin: center;
        transform: rotate(-141.5deg);
        stroke-dasharray: 339.292;
        stroke-dashoffset: 339.292;
        stroke: #7C99BA;
        transition: stroke-dashoffset 0.4s;
      }
    }
  }

  .gauge.gauge--voltage,
  .gauge.gauge--voltage .gauge__background {
    width: 244px;
    height: 120px;
    margin: 0;
  }

  .gauge.gauge--voltage .gauge__background {
    background: url('~@graphics/voltage_gauge.svg') center center;
    width: 100%;
    height: 100%;
    background-size: cover;
    border-radius: 0;
  }

  .gauge.gauge--voltage .gauge__dial-center {
    transform: translate3d(-50%, 488%, 0px) rotateZ(0deg);
    background: #fff;
  }

  .gauge.gauge--voltage .gauge__dial-center__indicator {
    height: 45px;
    transform: translate3d(-50%,-260%,0) rotate(0deg);
    transform-origin: 50% 100%;

    // &--overvoltage {
    //   background: $color-red;
    // }
  }

  .voltage-wrapper .voltage-content
  {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    text-align: center;
    color: #000;

    &__expected {
      font-size: 13px;
    }

    // &--overvoltage {
    //   color: $color-red;
    // }
  }
</style>
